export const techStack = [
  {
    id: 1,
    name: "Javascript",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },

  {
    id: 2,
    name: "TypeScript",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
  },

  {
    id: 3,
    name: "React",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
  },

  {
    id: 4,
    name: "Express",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
  },

  {
    id: 5,
    name: "NodeJS",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
  },
  {
    id: 6,
    name: "Mongo DB",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
  },

  // { name: "Flutter", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg" },
  // { name: "React Native", link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png" },
  {
    id: 7,
    name: "HTML",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    id: 8,
    name: "CSS",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
  },
  {
    id: 9,
    name: "Bootstrap",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
  },
  {
    id: 10,
    name: "Material-UI",
    link: "https://v4.material-ui.com/static/logo.png",
  },
  {
    id: 11,
    name: "Chakra-UI",
    link: "https://yt3.googleusercontent.com/ytc/AIf8zZRITxoo0byi4KcV1NSBN2cZknYjLTidLKfizJj2=s900-c-k-c0x00ffffff-no-rj",
  },
  {
    id: 12,
    name: "Sass",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg",
  },
  {
    id: 13,
    name: "Redux",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
  },
  {
    id: 14,
    name: "React-Query",
    link: "https://velog.velcdn.com/images/kjwsx23/post/9dee7b93-eadf-4439-967e-ef56092b3233/image.png",
  },

  {
    id: 15,
    name: "My SQL",
    link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5E2Vjpz0i7lTlzVNGqVsUkRy33TuHlmgm4w&usqp=CAU",
  },

  {
    id: 16,
    name: "Firebase",
    link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
  },
  {
    id: 17,
    name: "Postman",
    link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
  },

  {
    id: 18,
    name: "Heroku",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg",
  },
  {
    id: 19,
    name: "Git",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
  },

  {
    id: 20,
    name: "VS Code",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
  },
];

export const contactLinks = [
  {
    id: 1,
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/prakash817",
  },
  {
    id: 2,
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/prakash-gupta-pg/",
  },
];

export const project = [
  {
    id: 1,
    name: "CONNECT WITH ME",
    desc: " 'CONNECT WITH ME' social media app , this app is like social media where you can share your thought, post your picture , like/dislike the post of your friends and also connect with new friends . ",
    techstack: "React Javascript Nodejs Express Mongodb Material-ui",
    imgUrl:
      "https://cdn1.vectorstock.com/i/1000x1000/65/55/connection-connect-logo-for-apps-vector-24926555.jpg",
    gitLink: "https://github.com/prakash817/social_media",
    deployGitLink: "https://connect-with-me-main.onrender.com/",
  },
  {
    id: 2,
    name: "My Hour Clone",
    desc: "My Hours is a cloud-based time tracking website best suited for small teams and freelancers.A collaborative project built by 4 member team in 5 days .we have used vercel for deployment",
    techstack: "React Chakra-UI Redux Rest Api axios Framer-Motion",
    imgUrl:
      "data:image/png;base64,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",
    gitLink: "https://github.com/prakash817/myHours-clone",
    deployGitLink: "https://myhours.vercel.app/",
  },
  // {
  //   id: 2,
  //   name: "Meesho Clone",
  //   desc: "Meesho is an online e-commerce website it provides a large variety of products. A collaborative project built by 6 member team in 5 days. tech used are HTML ,CSS and JavaScript.we have used netlify for deployment",
  //   imgUrl:
  //     "https://upload.wikimedia.org/wikipedia/commons/8/80/Meesho_Logo_Full.png",
  //   gitLink: "https://github.com/prakash817/meesho",
  //   deployGitLink: "https://meeshoecom.netlify.app/",
  // },
  // {
  //   id: 3,
  //   name: "Netmeds Clone",
  //   desc: "Netmeds is a one of India's most trusted online pharmacy website . it is a collaborative project built by 5 member team. tech used are HTML ,CSS and JavaScript. we have used netlify for deployment",
  //   imgUrl:
  //     "https://seeklogo.com/images/N/netmeds-logo-4A3580CB35-seeklogo.com.png",
  //   gitLink: "https://github.com/prakash817/netmedspharmencyclone",
  //   deployGitLink: "https://bright-truffle-7e73b1.netlify.app",
  // },
  {
    id: 3,
    name: "CricInfo Clone",
    desc: "This repository is clone of cricInfo.com.The Cricinfo website is a popular online platform dedicated to cricket News. It is collaborative project built by five members in 5 days. In this we used HTML and CSS. We used Netlify for deployment.",
    techstack: "HTML,CSS ,Bootstrap",
    imgUrl:
      "https://www.indiantelevision.com/sites/default/files/styles/smartcrop_800x800/public/images/tv-images/2016/05/10/ESPN%20Cricinfo%20logo_1_0.png?itok=OclZ4T59",
    gitLink: "https://github.com/patelkavita/CricInfoProject",
    deployGitLink: "https://jazzy-bublanina-8265b5.netlify.app/",
  },
];
